import { useTracksSearchResult } from "frontend/src/domain/tracks/selectors";
import { usePagination } from "frontend/src/lib/pagination";
export var usePageModel = function () {
    var _a = usePagination({
        page: 0,
        rowsPerPage: 50,
        pageResetDeps: [],
    }), rowsPerPage = _a.rowsPerPage, skip = _a.skip, onChangeRowsPerPage = _a.onChangeRowsPerPage, onChangePage = _a.onChangePage, page = _a.page;
    var tracks = useTracksSearchResult({
        params: { search: null, genres: null, offset: skip, limit: rowsPerPage },
    });
    return { tracks: tracks, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, rowsPerPage: rowsPerPage, page: page };
};
